import devicesConnection from './devices-connection/devices-connection.module.js';

export default {
    devicesConnection,
};
